module.exports = __webpack_public_path__ + "static/media/checkbox-on.d74ae86e.svg";